export default {
  INTERACTIONS: (state) => state.interactions,
};
